import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { format } from 'date-fns';

import { EditorState, convertToRaw } from 'draft-js';
import { Editor } from 'react-draft-wysiwyg';
import actionWebInvoke from '../../utils/actionCallUtils';
import actions from '../../config.json';
import OBJCODE from '../../constants';

import PageSection from '../../components/Layout/Content/PageSection';
import DateTime from '../../components/Forms/DateTime';
import Budget from './Budget/index';
import Sponsors from './Lists/Sponsors';
import Templates from './Lists/Templates';
import Tags from './Tags';
import Inspiration from './Inspiration';
import callAEMUploadSDK from '../../components/assets/aemuploadsdk';
import {
  createFolderInAEM,
  getAEMFoldersAndFiles,
  UploadToFolderinAEM,
} from '../../components/assets/aemfileutils';
import {
  getWfFoldersAndFiles,
  createFolderInWF,
  wfUploadToFolder,
} from '../../components/assets/workfrontfileutils';
import FilesComponent from '../../components/assets/FilesComponent';
import getHeaders from '../../utils/headers';

import 'react-draft-wysiwyg/dist/react-draft-wysiwyg.css';

import {
  Wrap,
  Overview,
  LaunchDateTime,
  ExistingBriefs,
  Actions,
  Submit,
  EditorWrapper,
  EditorHeaderText,
} from './styles';

const BriefV2 = ({ user, ims }) => {
  const [loading, setLoading] = useState(false);
  const [title, setTitle] = useState('');
  const [budget, setBudget] = useState(0.0);
  const [launchDate, setLaunchDate] = useState(new Date());
  const [launchTime, setLaunchTime] = useState(new Date());
  const [tags, setTags] = useState([]);
  const [inspirationLinks, setInspirationLinks] = useState([]);
  const [sponsors, setSponsors] = useState({
    isLoading: true,
    elements: [],
    selected: '',
  });
  const [templates, setTemplates] = useState({
    isLoading: true,
    elements: [],
    selected: '',
  });

  const [editorState, setEditorState] = useState(() =>
    EditorState.createEmpty(),
  );

  const [convertedContent, setConvertedContent] = useState(null);

  const convertContentToHTML = () => {
    const currentContentAsHTML = JSON.stringify(
      convertToRaw(editorState.getCurrentContent()),
    );
    setConvertedContent(currentContentAsHTML);
  };

  const handleEditorChange = state => {
    setEditorState(state);
    convertContentToHTML();
  };

  const onFileChangeHandler = async e => {
    e.preventDefault();
    const file = e.target.files[0];
    console.log('file to upload', file);
    // getWfFoldersAndFiles('PROJ', '60c94b6000281f78f8b1db441e5d8528');
    // const wfFolder = await createFolderInWF(
    //   'New Folder',
    //   'PROJ',
    //   '60c94b6000281f78f8b1db441e5d8528',
    //   '',
    // );
    // wfUploadToFolder(file, 'PROJ', '60c94b6000281f78f8b1db441e5d8528', [
    //   `"${wfFolder.ID}"`,
    // ]);

    // createFolderInAEM(getHeaders(ims), 'New Folder', 'amex1/test');
    // getAEMFoldersAndFiles(getHeaders(ims), 'amex1/test');
    UploadToFolderinAEM(getHeaders(ims), file, 'nike');

    callAEMUploadSDK(file, ims.token);
  };

  const handleSubmit = async () => {
    setLoading(true);
    // Submit Project
    const queryParams = {
      name: title,
      plannedStartDate: `${format(launchDate, 'yyyy-MM-dd')}T${format(
        launchTime,
        'HH:mm:ss',
      )}`,
      sponsorID: sponsors.selected,
      templateID: templates.selected,
      budget,
      ownerID: user,
      'DE:AssetTags': tags.join(','),
      'DE:AssetLinks': inspirationLinks.join(','),
      method: 'post',
    };

    const actionResponse = await actionWebInvoke(
      actions['workfront-action'],
      {},
      { objCode: OBJCODE.PROJECT, queryParams },
    );
    console.log('Project created ID ', actionResponse.ID);

    await actionWebInvoke(
      actions['workfront-action'],
      {},
      {
        objCode: OBJCODE.PROJECT,
        objID: actionResponse.ID,
        bodyData: `{"DE:ProjDesc":${JSON.stringify(convertedContent)}}`,
      },
    );
    const projectURL = `${actionResponse.workfrontEndpoint}/project/${actionResponse.ID}/overview`;
    window.open(projectURL, '_blank');
    setLoading(true);
  };

  return (
    <Wrap>
      <PageSection title="Production Brief" showTakeMeTo={false}>
        {loading}
        <Sponsors sponsors={sponsors} setSponsors={setSponsors} />
        <Overview
          label="Project Overview"
          value={title}
          onChange={setTitle}
          placeholder="Title that describes project"
          width="750px"
          divider
        />
        <LaunchDateTime>
          <DateTime
            label="Launch Date"
            dateFormat="MM/dd/YYY"
            onChange={date => {
              console.log('date: ', date);
              setLaunchDate(date);
            }}
            value={launchDate}
            selected={launchDate}
            placeholderText="MM/dd/YYY"
          />
          <DateTime
            label="Launch Time"
            selected={launchTime}
            onChange={date => setLaunchTime(date)}
            showTimeSelect
            showTimeSelectOnly
            timeIntervals={5}
            timeCaption="Time"
            dateFormat="h:mm aa"
          />
        </LaunchDateTime>
        <Budget value={budget} onChange={setBudget} divider />
        <Templates templates={templates} setTemplates={setTemplates} />
        <EditorWrapper>
          <EditorHeaderText>Project Challenge</EditorHeaderText>
          <Editor
            toolbar={{
              options: ['inline', 'list', 'blockType', 'link'],
              inline: {
                inDropdown: false,
                options: ['bold', 'italic', 'underline'],
              },
              blockType: {
                inDropdown: false,
                options: ['Blockquote'],
              },
              list: {
                options: ['unordered', 'ordered'],
              },
              link: {
                options: ['link'],
              },
            }}
            placeholder="Description of the project"
            wrapperClassName="wrapper-class"
            editorClassName="editor-class"
            toolbarClassName="toolbar-class"
            editorState={editorState}
            onEditorStateChange={handleEditorChange}
          />
        </EditorWrapper>
        <Tags tags={tags} setTags={setTags} />
        <Inspiration
          inspirationLinks={inspirationLinks}
          setInspirationLinks={setInspirationLinks}
        />
        <input
          type="file"
          className="form-control"
          name="file"
          onChange={onFileChangeHandler}
        />
        <Actions>
          <Submit variant="cta" onPress={handleSubmit}>
            Submit
          </Submit>
        </Actions>
      </PageSection>
      <ExistingBriefs />
    </Wrap>
  );
};

BriefV2.propTypes = {
  user: PropTypes.string,
};

BriefV2.defaultProps = {
  user: '',
};

export default BriefV2;
